import { render } from "./UpgradePlan.vue?vue&type=template&id=21f25378"
import script from "./UpgradePlan.vue?vue&type=script&lang=ts"
export * from "./UpgradePlan.vue?vue&type=script&lang=ts"
script.render = render

export default script